import { DefaultLogo } from '@agilelab/plugin-wb-platform';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(
  theme => ({
    root: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100vh',
      gap: theme.spacing(3),
      padding: theme.spacing(4),
      backgroundColor: theme.palette.background.paper,
    },
    logo: {
      height: 48,
      width: 200,
    },
    icon: {
      fontSize: 96,
      color: theme.palette.primary.main,
    },
    title: {
      fontWeight: 700,
      textAlign: 'center',
    },
    description: {
      textAlign: 'center',
      maxWidth: 520,
      color: theme.palette.text.secondary,
    },
  }),
  { name: 'WitboostLicenseExpiredPage' },
);

export const LicenseExpiredPage = () => {
  const classes = useStyles();

  return (
    <main className={classes.root}>
      <Box className={classes.logo}>
        <DefaultLogo />
      </Box>

      <Typography variant="h3" className={classes.title}>
        Your license has expired
      </Typography>

      {/* icon? */}
      <svg
        width="200"
        height="200"
        viewBox="0 0 200 200"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        {/* dashed circle */}
        <circle
          cx="100"
          cy="100"
          r="90"
          stroke="#9dd0ec"
          strokeWidth="2.5"
          strokeDasharray="6 5"
          fill="#f8fbfe"
        />
        {/* warning triangle */}
        <polygon points="100,33 158,133 42,133" fill="#55add8" />
        {/* exclamation mark */}
        <text
          x="100"
          y="125"
          textAnchor="middle"
          fontSize="68"
          fontWeight="700"
          fontFamily="sans-serif"
          fill="#ffffff"
        >
          !
        </text>
      </svg>

      <Typography variant="body1" className={classes.description}>
        We&apos;re sorry, your license seems to be expired. <br /> Please{' '}
        <strong>contact our Customer Success</strong> to renew your license.
      </Typography>
    </main>
  );
};
